import { render } from "./HeaderComp.vue?vue&type=template&id=1b016197&scoped=true"
import script from "./HeaderComp.vue?vue&type=script&lang=js"
export * from "./HeaderComp.vue?vue&type=script&lang=js"

import "./HeaderComp.vue?vue&type=style&index=0&id=1b016197&scoped=true&lang=css"

import exportComponent from "C:\\Users\\manya\\Documents\\Development\\Production\\Vue\\bbf-africa-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b016197"]])

export default __exports__